import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const ResetIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M1.24138 10.2857C0.553448 10.2857 0 9.7125 0 9V1.28571C0 0.573214 0.553448 0 1.24138 0C1.92931 0 2.48276 0.573214 2.48276 1.28571V5.57679L3.51724 4.31786C5.63793 1.68214 8.83966 0 12.4138 0C18.8121 0 24 5.37321 24 12C24 18.6268 18.8121 24 12.4138 24C9.8069 24 7.39655 23.1054 5.46207 21.6C4.91379 21.1714 4.80517 20.3679 5.21379 19.8C5.62241 19.2321 6.40345 19.1196 6.95172 19.5429C8.47241 20.7268 10.3603 21.4286 12.4138 21.4286C17.4414 21.4286 21.5172 17.2071 21.5172 12C21.5172 6.79286 17.4414 2.57143 12.4138 2.57143C9.60517 2.57143 7.09138 3.88929 5.42069 5.96786L5.41552 5.97857L3.98793 7.71429H8.68966C9.37759 7.71429 9.93103 8.2875 9.93103 9C9.93103 9.7125 9.37759 10.2857 8.68966 10.2857H1.24138Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default ResetIcon
